import React, { useContext } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { appendMetadataWithIndex } from 'ml-portals-util-react';
import PropTypes from 'prop-types';
import appConfig from 'app-config';
import metadata from './CoverageTermsComponent.metadata.json5';
import styles from './CoverageTermsComponent.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function CoverageTermsComponent(props) {
    const {
        model: terms,
        covIndex
    } = props;
    const NO_TERM_VALUE = '-';
    const breakpoint = useContext(BreakpointTrackerContext)
    const isMobile = ['phone', 'phoneWide'].includes(breakpoint);
    const isQnB = appConfig.portalCode === 'QB';
    const isQBmobileUI = isMobile & isQnB

    const getTermValue = (term) => {
        const termVal = _.get(term, 'value', undefined);
        const chosenTermValue = _.get(term, 'chosenTermValue', undefined);
        if (!_.isUndefined(termVal)) {
            return termVal;
        }
        if (!_.isUndefined(chosenTermValue)) {
            return chosenTermValue;
        }
        return NO_TERM_VALUE;
    };

    const generateOverrides = () => {
        const overrides = terms.map((term, index) => {
            return {
                [`coverageTermNameCell${covIndex}${index}`]: {
                    content: isQBmobileUI ?(
                        <>
                        <strong>{_.get(term, 'name', '')}</strong>
                        <br/>
                        {getTermValue(term)}
                        </>
                    ) : _.get(term, 'name', ''),
                    className: isQBmobileUI ? 'coverageTermNameCellMobileQB cell' : 'cell'
                },
                [`coverageTermValueCell${covIndex}${index}`]: {
                    content: getTermValue(term),
                    visible: !isQBmobileUI
                },
                [`termContainer${covIndex}${index}coveragesTerms${covIndex}`]: {
                    className: 'tablerow qnbTableMobile'
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    const overrides = {
        [`coveragesTerms${covIndex}`]: {
            data: terms,
            className: 'tablerow qnbTableMobile'
        },
        ...generateOverrides()
    };
    const updatedMetadata = appendMetadataWithIndex(metadata.componentContent, covIndex);
    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} {...resolvers}/>;
}

CoverageTermsComponent.propTypes = {
    model: PropTypes.shape({}).isRequired,
    covIndex: PropTypes.number.isRequired,
};

export default CoverageTermsComponent;
